import {trans} from '@frontend/helpers'
import clsx from 'clsx'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {appUrl} from '../../../AppUrl'
import {AnalyticsEventReporter} from '../../../helpers/AnalyticsEventReporter'

interface Props {
    className?: string
    utmSource?: string
    gridOrder?: number
    colSpan?: number
}

// Продвижение объявлений.
export function PromoteYourAdsPromoCard(props: Props) {
    const {
        className,
        utmSource = 'promo_banners_block',
        gridOrder = 0,
        colSpan,
    } = props

    const url = NavigationService.makeFullUrl(
        appUrl().cabinet.ads.index,
        null,
        {utm_source: utmSource}
    )

    return (
        <Card
            className={clsx('promo-card promote-your-ad cursor', className)}
            style={{
                order: gridOrder,
                gridColumn: colSpan ? `span ${colSpan}` : undefined,
            }}
            onClick={() => {
                AnalyticsEventReporter.promoBannerClick('promote_your_ads', utmSource)
                window.open(url, '_blank')
            }}
        >
            <CardBody>
                <div className="promo-card-text">
                    <HtmlContent
                        html={trans().common.promo.promote_your_ads}
                        block
                    />
                </div>
            </CardBody>
        </Card>
    )
}
